var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full"},[(_vm.content.meta.title)?_c('h3',{staticClass:"block-title text-center"},[_c('span',{staticClass:"block-title-content theme-tinted-border"},[_vm._v(_vm._s(this.content.meta.title))])]):_vm._e(),_vm._v(" "),_c('videos',{attrs:{"videos":_vm.content.data.videos}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }